import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import { selectListItems } from "../../../../../../../redux/library/selector";
import { selectShipmentsListItems } from "../../../../../../../redux/shipments/selector";
import { shipments } from "../../../../../../../redux/shipments/action";
import PageLoader from "../../../../../../../components/PageLoader";
import Table from "../../../../../../../common/components/table";


const DBAShipments = ({ selectedDba }: any) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const libraryData = useSelector(selectListItems)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
  const itemsData = useSelector(selectShipmentsListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'OrderNumber', headerName: ' Order Number', searchField: 'OrderNumber', sortable: true, filter: true, filterType: 'text' },
      {
        field: 'ShippingStatusId',
        headerName: 'Shipment Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.ShippingStatus },
        isVendorShipmentEditable: true,
        sortable: true,
        filter: true
      },
      { field: 'TotalWeight', headerName: 'Total Weight' },
      { field: 'TrackingNumber', headerName: 'Tracking Number' },
      { field: 'ShippedDateUtc', headerName: 'Shipped Date', isDateValueFormat: true, sortable: true, filter: false },
      { field: 'DeliveryDateUtc', headerName: 'Delivery Date ', isDateValueFormat: true, sortable: true, filter: false },
      { field: 'OrderDate', headerName: 'Order Date ', isDateValueFormat: true, sortable: true, filter: false },
    ]);
  }

  
  
  const fetchShipments = () => {
    dispatch(shipments.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dom/shipments/list`,
      entity: 'shipments',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchShipments()
  }, [pageData,pageSize])

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleDelete = (data: any) => {
    dispatch(shipments.delete({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dom/shipments/delete`,
      entity: 'shipments',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      fetchShipments()
    });
  }
  const handleEdit = (data: any) => {
       navigate(`/management/dbn-cloud/dbas/${selectedDba?.DBAId}/shipments/${data?.Id}`)
  }
  const handleReloadData = () => {
    fetchShipments()
  }
  const additionButtons: any = [
    
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "OrderNumber",
        FieldText: "OrderNumber",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } 
    dispatch(shipments.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dom/shipments/list`,
      entity: 'shipments',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleShipmentStatusClick = async (event: any, dataId: any, reasonId: any) => {
    if (event === -10) {
      await dispatch(shipments.resetAction({ actionType: 'update' }))
      await dispatch(shipments.update({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dom/dbn/orders/status`,
        entity: 'shipments',
        jsonData: {
            Context: {},
          Records: [{
            ShipmentId: dataId.Id,
            ShippingStatusId: event,
            Code: reasonId,
           
          }]
        }
      })).then(() => {
        dispatch(shipments.list({
          url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dom/shipments/list`,
          entity: 'shipments',
          jsonData: {
            "PageNumber": pageData,
            "PageSize": pageSize,
            "SortField": "Id",
            "SortOrder": "desc",
          }
        }))
      });
    } else {
      await dispatch(shipments.resetAction({ actionType: 'update' }))
      await dispatch(shipments.update({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dom/dbn/orders/status`,
        entity: 'shipments',
        jsonData: {
            Context: {},
          Records: [{
            ShipmentId: dataId.Id,
            ShippingStatusId: event,
            Code: reasonId,
          
          }]
        }
      })).then(() => {
        dispatch(shipments.list({
          url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dom/shipments/list`,
          entity: 'shipments',
          jsonData: {
            "PageNumber": pageData,
            "PageSize": pageSize,
            "SortField": "Id",
            "SortOrder": "desc",
          }
        }))
      });
    }
  };

  return (
    <>
      {itemsData?.isLoading ?
        <PageLoader /> :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
        additionButtons={additionButtons} enableFilter={true} onSearch={handleSearch}  paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} 
          onShippingStatusClick={handleShipmentStatusClick} headingName="DBA Orders - Shippings" />
      }
    </>
  );
};

export default DBAShipments;


